import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 text-[#FC5106] animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center text-white">
        <div className="text-center">
          <p className="font-heading text-3xl font-bold mb-2">Access denied</p>
          <p className="text-white/60">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }
  return children;
}
